/**
 * Stack - Scroll carousel
 * Carrusel con scroll nativo (scroll-snap) y flechas opcionales.
 * Marcado:
 *   <stack-scroll-carousel>
 *     <button data-carousel-prev>…</button> <button data-carousel-next>…</button>
 *     <div data-carousel-track> …items… </div>
 *   </stack-scroll-carousel>
 * Las flechas avanzan un ítem (ancho + gap) y se desactivan en los extremos.
 */
if (!customElements.get('stack-scroll-carousel')) {
  class StackScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');

      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
      if (this.next) this.next.addEventListener('click', () => this.go(1));
      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    step() {
      const item = this.track.firstElementChild;
      if (!item) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    go(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      if (this.prev) this.prev.disabled = x <= 1;
      if (this.next) this.next.disabled = x >= max - 1;
      // Sin desbordamiento no hacen falta flechas
      this.classList.toggle('is-static', max <= 1);
    }
  }

  customElements.define('stack-scroll-carousel', StackScrollCarousel);
}
